import React, {
  ComponentType,
  createContext,
  ReactNode,
  useContext,
} from "react";

interface OutputContextType {
  value: boolean;
}

const OutputContext = createContext<OutputContextType | undefined>(undefined);

interface OutputProviderProps {
  value: boolean;
  children: ReactNode;
}

export const OutputProvider: React.FC<OutputProviderProps> = ({
  value,
  children,
}) => {
  return (
    <OutputContext.Provider value={{ value }}>
      {children}
    </OutputContext.Provider>
  );
};

export const useIsOutputMessage = (): boolean => {
  const context = useContext(OutputContext);
  return context?.value ?? false;
};

export const withOutputMessages = <P extends object>(
  Component: ComponentType<P>,
  value: boolean = true,
) => {
  const WrappedComponent = (props: P) => {
    return (
      <OutputProvider value={value}>
        <Component {...props} />
      </OutputProvider>
    );
  };

  WrappedComponent.displayName = `withOutputMessages(${
    Component.displayName || Component.name
  })`;

  return WrappedComponent;
};
